import React from 'react';

import { analytics } from '@opendoor/observability/slim';

import BuilderSalesPage from './BuilderSalesPage';

export interface IPartnersPageProps {
  partnerChannel: 'HOME_BUILDER';
  signUpRole: 'partner_sales_referrer';
  partnerIdentifier?: string;
}
class PartnersPage extends React.Component<IPartnersPageProps> {
  componentDidMount() {
    analytics.trackEvent('partner-sign-up-flow', 'view-landing-page');
  }

  render() {
    const { partnerChannel, signUpRole } = this.props;
    if (partnerChannel === 'HOME_BUILDER' && signUpRole === 'partner_sales_referrer') {
      return <BuilderSalesPage {...this.props} />;
    }
    return null;
  }
}

export default PartnersPage;
